var productCardMarkup =
	`
<ul>
		{{#products}} 
<a      class="grid-product__link">
	<li style="list-style: none;" {{da}} href="{{du}}"aria-label="{{dt}}" class="grid__item grid__item--collection-template small--one-half medium-up--one-quarter">
    <div class="grid-view-item product-card" style=" position: relative;">
<button style="background: #fff0;"id="swym-remove-productBtn" aria-label="Delete" data-variant-id="{{epi}}" data-product-id="{{empi}}" class="swym-delete-btn swym-nav swym-nav-1 swym-is-button"><span class="swym-icon">X</span></button>
		<div class="swym-wishlist-image-wrapper"><img alt="" class="swym-wishlist-image" src="{{iu}}"></div>
        <div class="grid-product__meta">
		<div class="grid-product__title grid-product__title--body" aria-hidden="true">{{dt}} </div>
        <div class="grid-product__price" data-price="">
          <span class="price-item price-item--sale" data-sale-price="">
            {{cu}}{{pr}}
          </span>
        </div>

      </div>

	  <select  name="variants_size" id="variants_select_{{empi}}"  style="border: 1px solid var(--asos-grey-40);width: 100%;"> 

	  </select>
	  <button hidden="hidden"   data-cart-submit="data-cart-submit"  id="swym-custom-add-toCartBtn"  data-add-to-cart name="add" type="submit" variant.available {{epi.available}}    name="add" data-state-cart="{{#isInCart}}swym-added{{/isInCart}}"data-product-url="{{du}}" data-variant-id="{{epi}}" data-product-id="{{empi}}"class="swym-custom-add-toCartBtn_{{empi}}   btn btn--full add-to-cart swym-add-to-cart-btn swym-button swym-button-1 swym-is-button swym-is-button">
     Add to cart
	  </button>

	  <div  id="errors_{{empi}}" style="position: absolute; z-index: 10; font-size: 10px;">
	  </div>
    </li> 
</a> 
       {{/products}}
</ul>	`;



function add_to_cart(e) {
	//var variantId = e;
	var variantId = document.getElementById(e).getAttribute('variant_id');
	var productId = document.getElementById(e).getAttribute('product_id');
	let formData = {
		'items': [{
			'id': variantId,
			'quantity': 1
		}]
	};
	fetch('/cart/add.js', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(formData)
		})

		.then(response => {
			return response.json();

		})
		.then(data => {

			if (data.status == 422) {
				console.log('Error:', data);
				document.getElementById('errors_' + productId).innerText = data.description;
				document.getElementById('errors_' + productId).className = " errors";

			} else {
				console.log('Success:', data);
				document.getElementById('errors_' + productId).innerText = '';
				document.getElementById('errors_' + productId).className = "";
				document.documentElement.dispatchEvent(new CustomEvent('ajaxProduct:added', {

					bubbles: true,
					detail: {
						variant: variantId,
						quantity: 1
					}
				}));
			}

		})
		.catch((error) => {
			console.error('Error:', error);
		});
}

function getVariantInfo(variants) {

	try {
		let variantKeys = ((variants && variants != "[]") ? Object.keys(JSON.parse(variants)[0]) : []),
			variantinfo;
		console.log(variantinfo, 'variantinfo');
		console.log(variantKeys, 'variantKeys');
		if (variantKeys.length > 0) {
			variantinfo = variantKeys[0];

			if (variantinfo == "Default Title") {
				variantinfo = variantKeys[0];
			}
		} else {

			variantinfo = "";
		}
		return variantinfo;
	} catch (err) {
		return variants;
	}
}
if (!window.SwymCallbacks) {
	window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymRenderWishlist); /* Init Here */

function swymRenderWishlist(swat) {


	console.log(swat)
	// Get wishlist items

	swat.fetch(function(products) {

		console.log(products);
		console.log(products.du);



		var wishlistContentsContainer = document.getElementById("wishlist-items-container");
		var formattedWishlistedProducts = products.map(function(p) {
			console.log(p)

			console.log(p.du)



			fetch(p.du + '.js').then(function(response) {
				return response.json()
			}).then(
				function(product) {
					//  let variant = product.variants.find(function(variant){ return variant.id == variant_id })
					// Do stuff with your product & variant objects
					console.log(product.title);
					console.log(product);
					console.log(product.variants.title);
					let text = '';
					
					for (let i = 0; i < product.variants.length; i++) {
						if (product.variants.length > 1) {

							text += " <option  data-cart-submit='data-cart-submit'   data-add-to-cart name='add' type='submit' name='add' data-state-cart='{{#isInCart}}swym-added{{/isInCart}}' data-product-url=" + product.url + " data-with-epi='true'  available= " + product.variants[i].available + "  value=" + product.variants[i].id + " variant_id=" + product.variants[i].id + "  product_id=" + product.id + " id=" + product.variants[i].id + '_' + product.id + " onclick='add_to_cart(this.id)'  data-swaction='addToWishlist' data-product-id=" + product.id + " data-variant-id=" + product.variants[i].id + " data-product-url='{{ shop.url }}{{ product.url }}' >" + product.variants[i].title + "</option>";

							document.getElementById('variants_select_' + product.id).innerHTML = text;


						}
						else {
							document.getElementById('variants_select_' + product.id).style.backgroundImage  = 'unset';
						}

					}

					document.getElementById('variants_select_'+product.id).addEventListener('change', function() {
						console.log(this.value);
						document.getElementsByClassName('swym-custom-add-toCartBtn_' + product.id)[0].setAttribute('data-variant-id', this.value);
					});
					setTimeout(() => {

						for (let i = 0; i < product.variants.length; i++) {
							if (product.variants[i].available == false) {

								document.getElementById(product.variants[i].id + "_" + product.id).style.color = 'gray';
								document.getElementById(product.variants[i].id + "_" + product.id).setAttribute('disabled', 'disabled');
							}
						}
					}, 1000)


				}
			)

			p = SwymUtils.formatProductPrice(p); // formats product price and adds currency to product Object
			p.isInCart = _swat.platform.isInDeviceCart(p.epi) || (p.et == _swat.EventTypes.addToCart);
			p.variantinfo = (p.vi ? getVariantInfo(p.vi) : "");
			console.log(getVariantInfo);
			return p;
		});
		var productCardsMarkup = SwymUtils.renderTemplateString(productCardMarkup, {
			products: formattedWishlistedProducts
		});
		if (wishlistContentsContainer) {
			wishlistContentsContainer.innerHTML = productCardsMarkup;
			attachClickListeners();
		} else {
			console.log("Container not found, Wishlist Page element not found");
		}

	});
}


function OpenDrawer() {

	document.documentElement.dispatchEvent(new CustomEvent('product:added', {
		bubbles: true,
		detail: {
			variant: "",
			quantity: 0
		}
	}));

}

function onAddToCartClick(e) {
	e.preventDefault();
	var productId = e.currentTarget.getAttribute("data-product-id");
	var variantId = e.currentTarget.getAttribute("data-variant-id");
	let formData = {
		'items': [{
			'id': variantId,
			'quantity': 1
		}]
	};
	fetch('/cart/add.js', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(formData)
		})

		.then(response => {
			return response.json();

		})
		.then(data => {


			if (data.status == 422) {
				console.log('Error:', data);
				//	document.getElementsByClassName('swym-custom-add-toCartBtn_'+productId)[0].setAttribute('disabled', 'disabled');
				document.getElementById('errors_' + productId).innerText = data.description;
				document.getElementById('errors_' + productId).className = " errors";


			} else {
				console.log('Success:', data);
				document.getElementById('errors_' + productId).innerText = '';
				document.getElementById('errors_' + productId).className = "";
				console.log(data.status, 'Status')
				document.documentElement.dispatchEvent(new CustomEvent('ajaxProduct:added', {

					bubbles: true,
					detail: {
						variant: variantId,
						quantity: 1
					}
				}));
			}


		})
		.catch((error) => {
			console.error('Error:', error);
		});
}

function attachClickListeners() {
	var addToCartButtons = document.querySelectorAll("#swym-custom-add-toCartBtn");
	var removeBtns = document.querySelectorAll("#swym-remove-productBtn");
	//   Add to cart Btns
	for (var i = 0; i < addToCartButtons.length; i++) {
		addToCartButtons[i].addEventListener('click', onAddToCartClick, false);
	}
	//   Remove Buttons
	for (var k = 0; k < removeBtns.length; k++) {
		removeBtns[k].addEventListener('click', onRemoveBtnClick, false);
	}
	console.log("Events attached!");
}

function onRemoveBtnClick(e) {

	e.preventDefault();
	var epi = +e.currentTarget.getAttribute("data-variant-id");
	var empi = +e.currentTarget.getAttribute("data-product-id");
	window._swat.fetch(function(products) {
		products.forEach(function(product) {
			if (epi && empi && product.epi == epi && product.empi == empi) {
				window._swat.removeFromWishList(product, function() {
					if (!window.SwymCallbacks) {
						window.SwymCallbacks = [];
					}
					window.SwymCallbacks.push(swymRenderWishlist);
				});
			}
		});
	})
}